import { VarejoAtacadoPromo } from "./VarejoAtacadoPromotion.styles";

export function VarejoAtacadoPromotion({
  product,
  styles,
  canvasScale,
  className,
}) {
  if (!product?.atacadoPrice) return null;

  return (
    <VarejoAtacadoPromo
      styles={styles}
      canvasScale={canvasScale}
      className={`varejo-atacado-span ${className || ""} flex`}
    >
      <p className="txt label">Atacado</p>
      <p className="txt atc-price">
        R${product.atacadoPrice.replace(".", ",")}
      </p>
      <p className="txt label">Varejo</p>
    </VarejoAtacadoPromo>
  );
}
